import { format } from 'date-fns';
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import BasePage from '../../components/BasePage';
import Fields from '../../components/Fields';
import { getStateUtil } from '../../components/Panels/PanelTicket';
import User from '../../components/User';
import ErrorPage from '../ErrorPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Timeline from '../../components/Timeline';
import config from '../../config.js';
import useAuth from '../../hooks/useAuth';
import BackButton from '../../components/Buttons/BackButton';


const DetailTicket = () => {
    const { id } = useParams(); // Récupération de l'ID depuis l'URL
    const containerRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    let ticket = false;

    const openMenu = () => {
        setIsOpen(!isOpen)
    }

    const closeMenu = () => {
        setIsOpen(false);
    }

    const content = (data) => {
        // Utilisez la variable data récupérée dans BasePage ici
        // Par exemple, vous pouvez afficher les données ou effectuer toute autre logique avec elles
        if (!data) {
            return false;
        }
        console.log(ticket);
        const fields = [
            {
                key: 'date_creation',
                name: 'Date de création',
                format: 'date_timestamp',
                date_format: 'dd/MM/yyyy HH:II:ss'
            }, {
                key: 'user_delegated_to',
                name: 'Délégué à',
                format: 'user'
            },
            // {
            //     key: 'date_delegated',
            //     name: 'Date de délégation',
            //     format: 'date',
            //     date_format: 'dd/MM/yyyy HH:II:ss'
            // },
            {
                key: 'date_read',
                name: 'Lu le',
                format: 'date_timestamp',
                date_format: 'dd/MM/yyyy HH:II:ss'
            }
        ]

        ticket = data.tickets.find((e) => e.id == id);
        let stateInfos = ticket ? getStateUtil(ticket.state) : null;

        return (
            <div id="detail-ticket" className="flex flex-col h-full">
                {!ticket ? (
                    <>
                        <ErrorPage msg="Ce ticket n'existe pas" nowrap={true} />
                    </>
                ) : (
                    <>
                        {/* <div className={`header-interne flex justify-center bg-[rgb(140_200_60/var(--tw-bg-opacity,1))] p-4 ${isSticky ? 'sticky-title' : ''}`}>
                            <BackButton />
                            <h1>Détail de la demande #{ticket.id}</h1>
                            
                        </div> */}
                        <div className={`header-interne flex justify-between items-center bg-[rgb(140_200_60/var(--tw-bg-opacity,1))] p-4 ${isSticky ? 'sticky-title' : ''}`}>
                            <BackButton />
                            <h1>Détail de la demande #{ticket.id}</h1>
                            <button
                                className="m-2 z-[1001] text-white"
                                onClick={openMenu}
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu">
                                <line x1="4" x2="20" y1="12" y2="12" />
                                <line x1="4" x2="20" y1="6" y2="6" />
                                <line x1="4" x2="20" y1="18" y2="18" />
                            </svg>
                            </button>
                        </div>

                        <div className="relative block flex flex-col grid grid-cols-1">

                            <div className="ticket-info p-4">
                                <div className="md:flex gap-10 mb-5">

                                    <div className="md:w-1/2">

                                        {ticket.titre && (
                                            <h2 className='font-bold text-[20px]'>{ticket.titre_txt} </h2>
                                        )}

                                        <Fields fields={fields} data={ticket} />
                                    </div>
                                    <div className="md:w-1/2">
                                        <div className="mt-2 ">
                                            <span className={`${stateInfos.class} text-white uppercase font-bold py-1 px-2 text-sm rounded-md`}>{stateInfos.label_name}</span>
                                        </div>

                                        {/* Afficher le commentaire uniquement si le ticket a été créé par le pro */}
                                        {ticket.user_id == 0 && (
                                            <div className="bloc-info p-10 mb-2 mt-8 flex gap-4 items-center">
                                                <FontAwesomeIcon className="text-mlime text-3xl" icon="fa-solid fa-comment" />
                                                <div className="">
                                                    <div className="font-bold text-lg">Commentaire</div>
                                                    <div>{ticket.commentaire}</div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>

                                {!ticket.user_delegated_to && (
                                    <div className="text-center my-4 text-orange-500 text-lg italic font-bold ">
                                        Votre demande a bien été reçue et sera bientôt traitée.
                                    </div>
                                )}
                            </div>

                            <hr className="mb-8" />

                            {ticket.actions && ticket.actions.length > 0 && (
                                <div className="actions-wrapper relative" >
                                    <h3 className="text-lg font-semibold mb-2 px-4">Actions</h3>
                                    <div className="actions relative pl-24 mt-10" ref={containerRef}>
                                        <div className="timeline absolute left-8 top-0 h-full w-10">
                                            <Timeline containerRef={containerRef} use_text={true} />
                                        </div>

                                        {ticket.actions.map((action, index, array) =>
                                            <>
                                                {/* Ligne verticale reliant les badges, sauf pour le dernier élément */}
                                                {/* {index > 0 && index < array.length && (
                                                    <div className="flex">
                                                        <div className="w-1/2 flex justify-center ">
                                                            <div className="w-px h-14 bg-gray-300"></div>
                                                        </div>
                                                    </div>
                                                )} */}

                                                {/* Badge pour la date */}
                                                {(ticket.actions[index - 1] && format(ticket.actions[index - 1].date_action, 'dd/MM/yyyy') != format(action.date_action, 'dd/MM/yyyy') || !ticket.actions[index - 1] || !ticket.actions[index - 1].observation) && (
                                                    <div className="timeline-header timeline-big-item" data-html={format(action.date_action, 'dd/MM/yyyy')}>
                                                    </div>
                                                )}

                                                <div className="timeline-entry pl-2 sm:pl-4 py-5 border-b timeline-item" data-html={format(action.date_action, 'HH:ii')}>
                                                    <div className="flex gap-2 items-center text-lg font-bold mb-2 item-title">
                                                        {/* <div className="font-normal rounded-full px-3 pt-0.5 py-1 text-sm text-white bg-mgray2 inline-block"> */}
                                                        {/* <em>{format(action.date_action, 'HH:ii')}</em> */}
                                                        {/* </div> */}
                                                        <FontAwesomeIcon className="text-mdark text" icon={`fa-solid ${data.actions_labels[action.type].icon}`} />
                                                        {data.actions_labels[action.type].title}
                                                    </div>

                                                    <div className="flex items-center justify-between">
                                                        <User user={action.user}></User>
                                                    </div>

                                                    <div className="mt-2">
                                                        {parseInt(action.rdv_pris) != 0 && (
                                                            <>
                                                                <br />
                                                                <span>Date du RDV : {format(action.rdv_pris, 'dd/MM/yyyy H:i')}</span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}

            </div>
        );
    };

    return <BasePage url="/liste" content={content} />;
}

export default DetailTicket;